import React from "react";
import { Element } from "react-scroll";
import { FaCertificate, FaExternalLinkAlt } from "react-icons/fa";
import "./Certifications.css";

const Certifications = () => {
  const certifications = [
    {
      title: "Data Science Master Course",
      provider: "Coding Blocks",
      period: "JULY 2025",
      certificateLink: "https://drive.google.com/file/d/1UjbjkKYYn2u_1fEVpmfZNygsoAbnOTgu/view?usp=sharing",
    },
    {
      title: "Pioneering Advances in NLP and Generative AI",
      provider: "Netaji Subhas University of Technology",
      period: "December 2024",
      certificateLink:
        "https://drive.google.com/file/d/1LbWRqukWlKb5nM21NNyDXF5DY6T7EAJO/view?usp=sharing",
    },
    {
      title: "Software Engineer Intern",
      provider: "HackerRank",
      period: "July 2025",
      certificateLink: "https://drive.google.com/file/d/1kWbvKxhet8wbiUY6xPGDv0NAy6DDZ6N_/view?usp=sharing",
    },
    {
      title: "Python for Data Science",
      provider: "IBM (edX)",
      period: "September 2023",
      certificateLink: "https://edx.org/certificate/example4",
    },
    {
      title: "Full Stack Web Development",
      provider: "freeCodeCamp",
      period: "December 2023",
      certificateLink: "https://freecodecamp.org/certificate/example5",
    },
    {
      title: "TensorFlow Developer Certificate",
      provider: "Google",
      period: "February 2024",
      certificateLink: "https://tensorflow.org/certificate/example6",
    },
  ];

  return (
    <Element name="certifications">
      <section className="certifications" style={{ padding: "2rem 2rem" }}>
        <div className="certifications-container">
          <h2 className="section-title">Certifications</h2>
          <div className="certifications-grid">
            {certifications.map((cert, index) => (
              <div
                key={index}
                className="certification-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="certification-icon">
                  <FaCertificate />
                </div>
                <div className="certification-content">
                  <h3>{cert.title}</h3>
                  <p className="certification-provider">{cert.provider}</p>
                  <p className="certification-period">{cert.period}</p>
                  <a
                    href={cert.certificateLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="certificate-link"
                  >
                    <FaExternalLinkAlt /> View Certificate
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Certifications;
